import { render, staticRenderFns } from "./DOTSPatientList.vue?vue&type=template&id=31653fe0&scoped=true"
import script from "./DOTSPatientList.vue?vue&type=script&lang=js"
export * from "./DOTSPatientList.vue?vue&type=script&lang=js"
import style0 from "./DOTSPatientList.vue?vue&type=style&index=0&id=31653fe0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31653fe0",
  null
  
)

export default component.exports